import { Link } from "react-router-dom";
import { Phone, MessageSquare, MapPin, Mail } from "lucide-react";
import { SITE } from "../lib/site";

export default function Footer() {
  return (
    <footer className="bg-[#0A192F] text-white pt-24 pb-10" data-testid="site-footer">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-full border border-[#C5A059] flex items-center justify-center text-[#C5A059] font-serif text-lg">
                R
              </span>
              <span className="font-serif text-2xl">Rhawn Auto Tag</span>
            </div>
            <p className="mt-6 font-serif text-3xl md:text-4xl leading-tight max-w-lg">
              Philadelphia's fastest counter for titles, tags, notary & auto insurance.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href={SITE.phoneHref} className="btn-gold text-sm" data-testid="footer-call">
                <Phone className="w-4 h-4" /> Call {SITE.phone}
              </a>
              <a
                href={SITE.smsHref}
                className="btn-ghost text-sm text-white border-white/50"
                data-testid="footer-text"
              >
                <MessageSquare className="w-4 h-4" /> Text Us
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="label-mini text-white/50">Navigate</div>
            <ul className="mt-5 space-y-3 text-white/85 text-sm">
              <li><Link to="/services" className="link-under">Services</Link></li>
              <li><Link to="/insurance" className="link-under">Auto Insurance</Link></li>
              <li><Link to="/notary" className="link-under">Notary</Link></li>
              <li><Link to="/about" className="link-under">About</Link></li>
              <li><Link to="/contact" className="link-under">Contact</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="label-mini text-white/50">Visit</div>
            <p className="mt-5 flex items-start gap-3 text-white/85">
              <MapPin className="w-4 h-4 text-[#C5A059] mt-1" />
              <span>{SITE.address}</span>
            </p>
            <p className="mt-3 flex items-start gap-3 text-white/85">
              <Phone className="w-4 h-4 text-[#C5A059] mt-1" />
              <a href={SITE.phoneHref}>{SITE.phone}</a>
            </p>
            <p className="mt-3 flex items-start gap-3 text-white/85">
              <Mail className="w-4 h-4 text-[#C5A059] mt-1" />
              <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
            </p>
            <div className="mt-6">
              <div className="label-mini text-white/50">Hours</div>
              <ul className="mt-3 text-white/85 text-sm space-y-1 font-mono-tab">
                {SITE.hours.map((h) => (
                  <li key={h.day} className="flex justify-between max-w-xs">
                    <span>{h.day}</span>
                    <span className="text-[#C5A059]">{h.time}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="hairline-gold mt-16 opacity-30" />

        {/* Third-party processing agency disclaimer */}
        <div className="mt-8 max-w-3xl text-[11px] leading-relaxed text-white/60 border border-[#C5A059]/30 bg-white/[0.02] p-4 rounded-sm">
          <span className="text-[#C5A059] font-medium">Disclaimer:</span> Rhawn
          Auto Tag is a <span className="text-white/90">privately owned, third-party
          processing agency</span>. We are <span className="text-white/90">not</span> a
          government entity, and we are not affiliated with, endorsed by, or an
          extension of the Pennsylvania Department of Transportation, any DMV,
          or any other state or federal agency. State fees are set by the
          Commonwealth of Pennsylvania and are collected on their behalf.
          Final acceptance of any application is subject to review by the
          applicable state agency.
        </div>

        <div className="mt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/50">
          <span>© {new Date().getFullYear()} Rhawn Auto Tag. Philadelphia, PA · Privately owned third-party processor.</span>
          <nav aria-label="Legal" className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link to="/legal/privacy" className="link-under" data-testid="footer-privacy">
              Privacy Policy
            </Link>
            <Link to="/legal/terms" className="link-under" data-testid="footer-terms">
              Terms &amp; Conditions
            </Link>
            <Link to="/contact" className="link-under" data-testid="footer-contact">
              Contact
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
